var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full items-center justify-between",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"w-full flex justify-start items-center"},[_c('p',{staticClass:"link-string ellipsis",on:{"click":_vm.onClickNameLink}},[_vm._v("\n      "+_vm._s(_vm.params.value)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }